import { useEffect } from 'react';

import Router from './routes';

import ThemeProvider from './theme';

import RtlLayout from './components/RtlLayout';
import ScrollToTop from './components/ScrollToTop';
import { ProgressBarStyle } from './components/ProgressBar';
import NotistackProvider from './components/NotistackProvider';
import ThemeColorPresets from './components/ThemeColorPresets';
import MotionLazyContainer from './components/animate/MotionLazyContainer';
import GlobalNotification from './containers/layouts/global-notification';

import useAuth from './hooks/useAuth';
import useBranding from './hooks/useBranding';

export default function App() {
  const { isAuthenticated } = useAuth();
  const branding = useBranding();

  // Apply brand identity to the document shell (tab title + favicon).
  useEffect(() => {
    if (isAuthenticated && branding.name) document.title = branding.name;

    const brandFavicon = isAuthenticated ? branding.favicon : null;
    document.querySelectorAll("link[rel~='icon']").forEach((link) => {
      if (!link.dataset.defaultHref) link.dataset.defaultHref = link.getAttribute('href');
      link.href = brandFavicon || link.dataset.defaultHref;
    });
  }, [isAuthenticated, branding.name, branding.favicon]);

  return (
    <ThemeProvider>
      <ThemeColorPresets>
        <RtlLayout>
          <NotistackProvider>
            <MotionLazyContainer>
              <ProgressBarStyle />
              <ScrollToTop />
              <Router />
              <GlobalNotification />
            </MotionLazyContainer>
          </NotistackProvider>
        </RtlLayout>
      </ThemeColorPresets>
    </ThemeProvider>
  );
}
